export default __webpack_public_path__ + "paddle_trafficbd0179.svg";